import { render, staticRenderFns } from "./AITable.vue?vue&type=template&id=7a6ac040&scoped=true"
import script from "./AITable.vue?vue&type=script&lang=js"
export * from "./AITable.vue?vue&type=script&lang=js"
import style0 from "./AITable.vue?vue&type=style&index=0&id=7a6ac040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6ac040",
  null
  
)

export default component.exports